export default "__VITE_ASSET__BXc3lgIk__"